/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React from "react";
import {NavLink} from "react-router-dom";


const SideBar = () =>{
   return(
       <>
           <div id="layoutSidenav_nav">
               <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">

                   <div className="sb-sidenav-menu">

                       <div className="nav">
                           <div className="sb-sidenav-menu-heading">Core</div>
                           <NavLink className="nav-link" to="/">
                               <div className="sb-nav-link-icon"><i className="fas fa-truck-pickup"/></div>
                               Dashboard
                           </NavLink>
                           <div className="sb-sidenav-menu-heading">Order Management</div>
                           <NavLink className="nav-link" to="/truck">
                               <div className="sb-nav-link-icon"><i className="fas fa-truck-pickup"/></div>
                              Truck List
                           </NavLink>
                           <NavLink className="nav-link" to="/appointment">
                               <div className="sb-nav-link-icon"><i className="fas fa-calendar-check"/></div>
                               Appointment List
                           </NavLink>
                           <NavLink activeClassName={'active'} className="nav-link" to="/schedule">
                               <div className="sb-nav-link-icon"><i className="far fa-clock"/></div>
                               Schedule List
                           </NavLink>
                           <div className="sb-sidenav-menu-heading">Customer Management</div>
                           <NavLink className="nav-link" to="/customer-list">
                               <div className="sb-nav-link-icon"><i className="fas fa-user"/></div>
                               Customer List
                           </NavLink>
                           <div className="sb-sidenav-menu-heading">Report Management</div>
                           <NavLink className="nav-link" to="/report">
                               <div className="sb-nav-link-icon"><i className="fas fa-chart-area"/></div>
                               Report
                           </NavLink>
                       </div>
                   </div>
                   <div className="sb-sidenav-footer">
                       <div className="small">Logged in as:</div>
                       {localStorage.name != undefined? localStorage.name : null}
                   </div>
               </nav>
           </div>
       </>
   )
}
export default SideBar